interface FeaturedPublication {
  name: string
  href: string
}

// Edit this list to update the "Featured On" marquee.
const publications: FeaturedPublication[] = [
  { name: 'The Dance Enthusiast', href: 'https://www.dance-enthusiast.com/' },
  { name: 'Dance Films Association', href: 'https://www.dancefilms.org/' },
  { name: '5×5 Dance Festival', href: 'https://www.5x5dance.com/' },
  { name: 'JUMP/CUT', href: '#' },
  { name: 'Bridge for Dance', href: '#' },
  { name: 'Los Angeles Dance Festival', href: '#' },
  { name: 'The Texarkana Gazette', href: 'https://www.texarkanagazette.com/' },
]

export function FeaturedOnSection() {
  if (publications.length === 0) return null

  return (
    <section className="border-t py-16">
      <div className="container mx-auto px-4">
        <p className="mb-8 text-center text-xs font-semibold uppercase tracking-[0.3em] text-muted-foreground">
          Featured On
        </p>

        <ul className="flex flex-wrap items-center justify-center gap-x-10 gap-y-6 sm:gap-x-14">
          {publications.map(({ name, href }) => (
            <li key={name}>
              <a
                href={href}
                target="_blank"
                rel="noopener noreferrer"
                className="text-lg font-semibold tracking-tight text-muted-foreground/80 transition-colors hover:text-foreground sm:text-xl"
              >
                {name}
              </a>
            </li>
          ))}
        </ul>
      </div>
    </section>
  )
}
